<script>
  import Link from '/Atoms/Link'

  export let link = false, invertColor = false, hover = false, almanac = false, icon = null

</script>

<div class="container" class:almanac on:click class:hover={ link || hover }>
  <span class="content">
    {#if link}
      <Link hover="none" to={link}>
        <slot />
      </Link>
    {:else}
      <slot />
    {/if}
  </span>
</div>

<style lang="scss">
  .container {
    & {
      @include typo-grotesk-text-24;
      @include media-large-and-less { // breaks at unusual breakpoint
        @include typo-grotesk-text-24-small;
      }
    }

    &.almanac {
      @include typo-serif-small-caps-24;
      background-color: $color-beige;
      color: black;
      padding: 0 1.65ex;
      .content {
        position: relative;
        top: -0.2em;
      }
    }

    @include box-shadow;
    &.hover:hover {
      box-shadow: $link-hover-shadow;
      cursor: pointer;
    }
    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: $color-red;
    color: $color-beige;

    position: relative;
    top: 2px;

    height: 40px;
    border-radius: 20px;
    padding: 0 1ex;
    @include media-large-and-less { // breaks at unusual breakpoint
      height: 34px;
      border-radius: 17px;
    }
    
    margin-right: 0.2em;
    user-select: none;
  }

</style>